import { render, staticRenderFns } from "./ContatoInstitucional.vue?vue&type=template&id=4379852e&"
import script from "./ContatoInstitucional.vue?vue&type=script&lang=js&"
export * from "./ContatoInstitucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports